(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-password"] && !Shopify.designMode) return;
  try {
    
  const passwordPages = document.querySelectorAll('.sg-password[data-launch-date]');

  passwordPages.forEach((page) => {
    const target = new Date(page.dataset.launchDate).getTime();
    const days = page.querySelector('[data-countdown-days]');
    const hours = page.querySelector('[data-countdown-hours]');
    const minutes = page.querySelector('[data-countdown-minutes]');
    const seconds = page.querySelector('[data-countdown-seconds]');

    const updateCountdown = () => {
      const remaining = Math.max(0, target - Date.now());
      const dayValue = Math.floor(remaining / 86400000);
      const hourValue = Math.floor((remaining % 86400000) / 3600000);
      const minuteValue = Math.floor((remaining % 3600000) / 60000);
      const secondValue = Math.floor((remaining % 60000) / 1000);

      days.textContent = String(dayValue).padStart(2, '0');
      hours.textContent = String(hourValue).padStart(2, '0');
      minutes.textContent = String(minuteValue).padStart(2, '0');
      seconds.textContent = String(secondValue).padStart(2, '0');
    };

    updateCountdown();
    window.setInterval(updateCountdown, 1000);
  });

  } catch(e) { console.error(e); }
})();
})();
